var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLethnerBgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 750,
    height: 293,
    viewBox: "0 0 750 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:url(#a);}.c{clip-path:url(#b);}.d{opacity:0.49;}.e,.g,.q{fill:#fcfffe;}.e,.f{opacity:0.29;}.ac,.h{opacity:0.23;}.i{opacity:0.37;fill:url(#c);}.j{opacity:0.44;}.k{fill:rgba(81,67,158,0.1);}.l,.m,.n,.o{opacity:0.1;}.l{fill:url(#e);}.m{fill:url(#f);}.n{fill:url(#g);}.o{fill:url(#h);}.p{opacity:0.33;fill:url(#i);}.q{opacity:0.39;}.r{fill:rgba(0,0,0,0.4);opacity:0.11;}.ac,.s{fill:#fff;}.t{fill:rgba(195,203,212,0.7);}.u{fill:#c7cace;}.v{fill:#34a853;}.w{fill:#3fab99;font-size:78px;font-family:MaterialDesignIcons, Material Design Icons;}.x{fill:#fcfeff;}.y{fill:#8898aa;}.z{fill:#eceff2;}.aa{fill:#172b4d;}.ab{fill:#fcb449;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.324,
    y1: 0.448,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9905"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 750,
    height: 293,
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f3f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a79af2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51439e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eceff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7c7c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.39 -61.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 750,
    height: 293,
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(61.68 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(62.37 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(63.06 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(63.75 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(64.44 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(65.13 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(65.82 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3.25,150.05a2.57,2.57,0,1,0-2.56,2.57,2.56,2.56,0,0,0,2.56-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.56,170a1.88,1.88,0,1,0-.54,1.339A1.88,1.88,0,0,0,2.56,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1.87,190a1.19,1.19,0,1,0-1.18,1.18A1.18,1.18,0,0,0,1.87,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(76.46 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(77.15 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(77.84 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(78.53 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(79.22 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(79.91 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(80.6 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M18,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,18,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M17.34,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,17.34,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.65,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,16.65,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(91.24 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(91.93 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(92.62 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(93.31 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(94 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(94.69 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(95.38 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.81,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.12,170a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,32.12,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M31.43,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,31.43,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(106.02 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(106.71 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(107.4 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(108.09 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(108.78 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(109.47 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(110.16 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M47.58,150.05a2.56,2.56,0,1,0-.753,1.824,2.56,2.56,0,0,0,.753-1.824Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M46.89,170a1.88,1.88,0,1,0-.547,1.346A1.88,1.88,0,0,0,46.89,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M46.2,190a1.18,1.18,0,1,0-.353.842A1.19,1.19,0,0,0,46.2,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(120.79 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(121.48 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(122.17 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(122.86 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(123.55 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(124.24 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(124.93 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M62.36,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,62.36,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M61.67,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,61.67,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M61,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,61,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(135.57 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(136.26 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(136.95 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(137.64 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(138.33 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(139.02 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(139.71 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M77.14,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M76.45,170a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,76.45,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M75.76,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,75.76,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(150.35 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(151.04 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(151.73 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(152.42 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(153.11 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(153.8 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(154.49 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M91.91,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M91.22,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,91.22,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M90.53,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,90.53,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(165.12 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(165.81 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(166.5 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(167.19 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(167.88 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(168.57 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(169.26 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M106.69,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M106,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,106,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M105.31,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,105.31,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(179.9 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(180.59 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(181.28 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(181.97 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(182.66 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(183.35 167.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M122.16,130.08a3.25,3.25,0,1,0-.955,2.3,3.26,3.26,0,0,0,.955-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M121.47,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M120.78,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M120.09,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(194.68 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(195.37 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(196.06 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(196.75 125.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M138.31,90.13a4.63,4.63,0,1,0-4.63,4.63,4.63,4.63,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M137.62,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.93,130.08a3.24,3.24,0,1,0-.949,2.3A3.25,3.25,0,0,0,136.93,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.24,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,136.24,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M135.55,170a1.87,1.87,0,1,0-1.87,1.87,1.87,1.87,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M134.86,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,134.86,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(209.45 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(210.14 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(210.83 105.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M153.78,70.16a5.32,5.32,0,1,0-5.32,5.32,5.32,5.32,0,0,0,5.32-5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M153.09,90.13a4.64,4.64,0,1,0-4.63,4.63,4.64,4.64,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M152.4,110.11a3.95,3.95,0,1,0-3.94,3.94A3.95,3.95,0,0,0,152.4,110.11Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M151.71,130.08a3.26,3.26,0,1,0-3.25,3.25A3.26,3.26,0,0,0,151.71,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M151,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,151,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M150.33,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M149.64,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,149.64,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(224.23 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(224.92 84.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M169.24,50.19a6,6,0,1,0-6,6,6,6,0,0,0,6-6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M168.55,70.16a5.32,5.32,0,1,0-5.32,5.32,5.32,5.32,0,0,0,5.32-5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.86,90.13a4.63,4.63,0,1,0-4.63,4.63,4.63,4.63,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.17,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M166.49,130.08a3.25,3.25,0,1,0-.955,2.3A3.26,3.26,0,0,0,166.49,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M165.8,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M165.11,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M164.42,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,164.42,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(239.01 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(239.7 84.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184,50.19a6,6,0,1,0-6,6A6,6,0,0,0,184,50.19Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M183.33,70.16a5.32,5.32,0,1,0-1.562,3.765,5.32,5.32,0,0,0,1.562-3.765Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M182.64,90.13a4.63,4.63,0,1,0-1.36,3.277,4.63,4.63,0,0,0,1.36-3.277Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M182,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M181.26,130.08a3.24,3.24,0,1,0-.949,2.3A3.25,3.25,0,0,0,181.26,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M180.57,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M179.88,170a1.88,1.88,0,1,0-.543,1.342A1.87,1.87,0,0,0,179.88,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M179.19,190a1.18,1.18,0,1,0-1.18,1.18A1.18,1.18,0,0,0,179.19,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(253.78 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(254.47 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(255.16 105.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M198.11,70.16a5.32,5.32,0,1,0-5.32,5.32A5.32,5.32,0,0,0,198.11,70.16Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M197.42,90.13a4.63,4.63,0,1,0-4.63,4.63,4.63,4.63,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M196.73,110.11a3.95,3.95,0,1,0-3.94,3.94,3.95,3.95,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M196,130.08a3.26,3.26,0,1,0-3.25,3.25A3.26,3.26,0,0,0,196,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M195.35,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M194.66,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M194,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,194,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(268.56 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(269.25 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(269.94 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(270.63 125.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M212.19,90.13a4.63,4.63,0,1,0-4.63,4.63A4.63,4.63,0,0,0,212.19,90.13Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.51,110.11a3.95,3.95,0,1,0-3.95,3.94A4,4,0,0,0,211.51,110.11Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M210.82,130.08a3.25,3.25,0,1,0-.955,2.3,3.26,3.26,0,0,0,.955-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M210.13,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M209.44,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M208.75,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(283.34 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(284.03 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(284.72 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(285.41 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(286.1 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(286.79 167.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M225.59,130.08a3.24,3.24,0,1,0-.949,2.3,3.25,3.25,0,0,0,.949-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M224.9,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,224.9,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M224.21,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,224.21,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M223.52,190a1.18,1.18,0,1,0-1.18,1.18,1.18,1.18,0,0,0,1.18-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(298.11 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(298.8 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(299.49 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(300.18 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(300.87 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(301.56 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(302.25 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.68,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,239.68,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,239,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M238.3,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,238.3,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(312.89 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(313.58 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(314.27 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(314.96 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(315.65 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(316.34 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(317.03 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M254.46,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M253.77,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M253.08,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(327.67 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(328.36 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(329.05 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(329.74 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(330.43 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(331.12 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(331.81 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M269.23,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,269.23,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M268.54,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,268.54,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M267.86,190a1.19,1.19,0,1,0-1.19,1.18,1.19,1.19,0,0,0,1.19-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(342.44 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(343.13 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(343.82 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(344.51 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(345.2 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(345.89 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(346.58 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M284,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,284,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M283.32,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M282.63,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,282.63,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(357.22 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(357.91 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(358.6 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(359.29 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(359.98 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(360.67 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(361.36 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.79,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.1,170a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,298.1,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M297.41,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,297.41,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(372 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(372.69 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(373.38 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(374.07 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(374.76 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(375.45 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(376.14 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M313.56,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M312.88,170a1.88,1.88,0,1,0-.543,1.342A1.88,1.88,0,0,0,312.88,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M312.19,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,312.19,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(386.77 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(387.46 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(388.15 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(388.84 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(389.53 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(390.22 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(390.91 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M328.34,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M327.65,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M327,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,327,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(401.55 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(402.24 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(402.93 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(403.62 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(404.31 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(405 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(405.69 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M343.12,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M342.43,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M341.74,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,341.74,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(416.33 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(417.02 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(417.71 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(418.4 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(419.09 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(419.78 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(420.47 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M357.89,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M357.21,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M356.52,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(431.1 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(431.79 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(432.48 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(433.17 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(433.86 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(434.55 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(435.24 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M372.67,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M372,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,372,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M371.29,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,371.29,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(445.88 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(446.57 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(447.26 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(447.95 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(448.64 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(449.33 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(450.02 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M387.45,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M386.76,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M386.07,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(460.66 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(461.35 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(462.04 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(462.73 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(463.42 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(464.11 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(464.8 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M402.23,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M401.54,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M400.85,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(475.44 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(476.13 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(476.82 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(477.51 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(478.2 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(478.89 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(479.58 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M417,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,417,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M416.31,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M415.62,190a1.19,1.19,0,1,0-1.18,1.18,1.19,1.19,0,0,0,1.18-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(490.21 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(490.9 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(491.59 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(492.28 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(492.97 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(493.66 167.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M432.47,130.08a3.26,3.26,0,1,0-3.25,3.25,3.26,3.26,0,0,0,3.25-3.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M431.78,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M431.09,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M430.4,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,430.4,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(504.99 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(505.68 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(506.37 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(507.06 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(507.75 146.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M447.93,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M447.24,130.08a3.24,3.24,0,1,0-.949,2.3A3.25,3.25,0,0,0,447.24,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M446.56,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M445.87,170a1.88,1.88,0,1,0-.54,1.339,1.88,1.88,0,0,0,.54-1.339Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M445.18,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,445.18,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(519.77 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(520.46 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(521.15 105.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M464.09,70.16a5.32,5.32,0,1,0-5.32,5.32,5.32,5.32,0,0,0,5.32-5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M463.4,90.13a4.63,4.63,0,1,0-4.63,4.63A4.63,4.63,0,0,0,463.4,90.13Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M462.71,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M462,130.08a3.24,3.24,0,1,0-.949,2.3,3.25,3.25,0,0,0,.949-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M461.33,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M460.64,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M460,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,460,190Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(534.54 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(535.23 84.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M479.56,50.19a6,6,0,1,0-6,6A6,6,0,0,0,479.56,50.19Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M478.87,70.16a5.32,5.32,0,1,0-5.32,5.32A5.32,5.32,0,0,0,478.87,70.16Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M478.18,90.13a4.64,4.64,0,1,0-4.63,4.63,4.64,4.64,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M477.49,110.11a3.95,3.95,0,1,0-3.94,3.94A3.95,3.95,0,0,0,477.49,110.11Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M476.8,130.08a3.26,3.26,0,1,0-3.25,3.25,3.26,3.26,0,0,0,3.25-3.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M476.11,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,476.11,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M475.42,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M474.73,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,474.73,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(549.32 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(550.01 84.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M494.33,50.19a6,6,0,1,0-6,6,6,6,0,0,0,6-6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M493.64,70.16a5.32,5.32,0,1,0-5.32,5.32A5.32,5.32,0,0,0,493.64,70.16Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M493,90.13a4.63,4.63,0,1,0-4.63,4.63A4.63,4.63,0,0,0,493,90.13Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M492.26,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M491.58,130.08a3.25,3.25,0,1,0-.955,2.3,3.26,3.26,0,0,0,.955-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M490.89,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M490.2,170a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,490.2,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M489.51,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,489.51,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(564.1 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(564.79 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(565.48 105.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M508.42,70.16a5.32,5.32,0,1,0-5.32,5.32,5.32,5.32,0,0,0,5.32-5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M507.73,90.13a4.63,4.63,0,1,0-4.63,4.63,4.63,4.63,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M507,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M506.35,130.08a3.24,3.24,0,1,0-.949,2.3,3.25,3.25,0,0,0,.949-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M505.66,150.05a2.56,2.56,0,1,0-.746,1.817,2.56,2.56,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M505,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,505,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M504.28,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,504.28,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(578.87 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(579.56 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(580.25 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(580.94 125.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M522.51,90.13a4.64,4.64,0,1,0-4.63,4.63,4.64,4.64,0,0,0,4.63-4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M521.82,110.11a3.95,3.95,0,1,0-3.94,3.94,3.95,3.95,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M521.13,130.08a3.26,3.26,0,1,0-3.25,3.25A3.26,3.26,0,0,0,521.13,130.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M520.44,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,520.44,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M519.75,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M519.06,190a1.19,1.19,0,1,0-1.18,1.18,1.19,1.19,0,0,0,1.18-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(593.65 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(594.34 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(595.03 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(595.72 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(596.41 146.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M536.59,110.11a3.94,3.94,0,1,0-3.94,3.94,3.94,3.94,0,0,0,3.94-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M535.91,130.08a3.25,3.25,0,1,0-.955,2.3,3.26,3.26,0,0,0,.955-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M535.22,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M534.53,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M533.84,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,533.84,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(608.43 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(609.12 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(609.81 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(610.5 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(611.19 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(611.88 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(612.57 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M550,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,550,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M549.3,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,549.3,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M548.61,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,548.61,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(623.2 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(623.89 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(624.58 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(625.27 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(625.96 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(626.65 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(627.34 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M564.77,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M564.08,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M563.39,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,563.39,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(637.98 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(638.67 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(639.36 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(640.05 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(640.74 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(641.43 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(642.12 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M579.55,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M578.86,170a1.88,1.88,0,1,0-1.86,1.9,1.88,1.88,0,0,0,1.86-1.9Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M578.17,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,578.17,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(652.76 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(653.45 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(654.14 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(654.83 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(655.52 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(656.21 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(656.9 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M594.32,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,594.32,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M593.63,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,593.63,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M592.94,190a1.18,1.18,0,1,0-1.18,1.18A1.18,1.18,0,0,0,592.94,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(667.53 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(668.22 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(668.91 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(669.6 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(670.29 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(670.98 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(671.67 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M609.1,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,609.1,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M608.41,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M607.72,190a1.19,1.19,0,1,0-1.18,1.18,1.19,1.19,0,0,0,1.18-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(682.31 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(683 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(683.69 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(684.38 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(685.07 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(685.76 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(686.45 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M623.88,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M623.19,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M622.5,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,622.5,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(697.09 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(697.78 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(698.47 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(699.16 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(699.85 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(700.54 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(701.23 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M638.65,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,638.65,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M638,170a1.87,1.87,0,1,0-1.87,1.87A1.87,1.87,0,0,0,638,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M637.28,190a1.19,1.19,0,1,0-1.19,1.18,1.19,1.19,0,0,0,1.19-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(711.86 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(712.55 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(713.24 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(713.93 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(714.62 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(715.31 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(716 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M653.43,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,653.43,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M652.74,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M652.05,190a1.19,1.19,0,1,0-1.18,1.18,1.19,1.19,0,0,0,1.18-1.18Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(726.64 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(727.33 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(728.02 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(728.71 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(729.4 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(730.09 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(730.78 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M668.21,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M667.52,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M666.83,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(741.42 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(742.11 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(742.8 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(743.49 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(744.18 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(744.87 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(745.56 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M683,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,683,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M682.29,170a1.87,1.87,0,1,0-1.87,1.87,1.87,1.87,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M681.61,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,681.61,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(756.19 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(756.88 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(757.57 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(758.26 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(758.95 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(759.64 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(760.33 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M697.76,150.05a2.56,2.56,0,1,0-.746,1.817A2.57,2.57,0,0,0,697.76,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M697.07,170a1.88,1.88,0,1,0-1.87,1.87,1.88,1.88,0,0,0,1.87-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M696.38,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,696.38,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(770.97 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(771.66 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(772.35 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(773.04 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(773.73 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(774.42 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(775.11 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M712.54,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M711.85,170a1.88,1.88,0,1,0-1.85,1.9A1.88,1.88,0,0,0,711.85,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M711.16,190a1.18,1.18,0,1,0-.349.838A1.19,1.19,0,0,0,711.16,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(785.75 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(786.44 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(787.13 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(787.82 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(788.51 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(789.2 167.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(789.89 187.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M727.31,150.05a2.56,2.56,0,1,0-.746,1.817A2.56,2.56,0,0,0,727.31,150.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M726.63,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M725.94,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(800.52 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(801.21 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(801.9 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(802.59 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(803.28 146.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.94,
    cy: 3.94,
    r: 3.94,
    transform: "translate(803.97 167.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M742.78,130.08a3.25,3.25,0,1,0-3.25,3.25,3.25,3.25,0,0,0,3.25-3.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M742.09,150.05a2.56,2.56,0,1,0-.746,1.817,2.57,2.57,0,0,0,.746-1.817Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M741.4,170a1.88,1.88,0,1,0-1.87,1.87A1.88,1.88,0,0,0,741.4,170Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M740.71,190a1.19,1.19,0,1,0-1.18,1.18A1.19,1.19,0,0,0,740.71,190Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(815.3 63.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(815.99 84.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(816.68 105.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(817.37 125.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(818.06 146.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M758.25,110.11a3.95,3.95,0,1,0-4,3.94,4,4,0,0,0,4-3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M757.56,130.08a3.25,3.25,0,1,0-.955,2.3,3.26,3.26,0,0,0,.955-2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M756.87,150.05a2.57,2.57,0,1,0-2.57,2.57,2.57,2.57,0,0,0,2.57-2.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M756.18,170a1.88,1.88,0,1,0-1.88,1.87,1.88,1.88,0,0,0,1.88-1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M755.49,190a1.18,1.18,0,1,0-.349.838,1.19,1.19,0,0,0,.349-.838Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(63.75 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(64.44 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(65.13 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(65.82 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(66.51 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6.7,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,6.7,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,6,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M5.32,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(69.27 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(69.96 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(78.53 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(79.22 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(79.91 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(80.6 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(81.29 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M21.47,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,21.47,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M20.79,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,20.79,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M20.1,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(84.05 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(84.74 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(93.31 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(94 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(94.69 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(95.38 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(96.07 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.25,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,36.25,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M35.56,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.87,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,34.87,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(98.83 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(99.52 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(108.08 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(108.77 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(109.46 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(110.15 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(110.84 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M51,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,51,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M50.34,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,50.34,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M49.65,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,49.65,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(113.6 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(114.29 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(122.86 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(123.55 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(124.24 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(124.93 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(125.62 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M65.81,395a3.94,3.94,0,1,1-1.175-2.807A3.95,3.95,0,0,1,65.81,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M65.12,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,65.12,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M64.43,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(128.38 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(129.07 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(137.64 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(138.33 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(139.02 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(139.71 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(140.4 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M80.58,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,80.58,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.89,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,79.89,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.2,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,79.2,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(143.16 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(143.85 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(152.41 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(153.1 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(153.79 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(154.48 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(155.17 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M95.36,395a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,95.36,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.67,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,94.67,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,94,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M93.29,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.6,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(167.19 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(167.88 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(168.57 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(169.26 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(169.95 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M110.14,395a3.94,3.94,0,1,1-1.175-2.807A3.95,3.95,0,0,1,110.14,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M109.45,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M108.76,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M108.07,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,108.07,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M107.38,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(181.97 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(182.66 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(183.35 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(184.04 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(184.73 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M124.91,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,124.91,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M124.22,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,124.22,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M123.53,355.05a2.56,2.56,0,1,1-2.56-2.56,2.56,2.56,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M122.84,335.08a1.86,1.86,0,1,1-.545-1.325,1.87,1.87,0,0,1,.545,1.325Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M122.16,315.11a1.19,1.19,0,1,1-1.19-1.19,1.19,1.19,0,0,1,1.19,1.19Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(196.74 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(197.43 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(198.12 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(198.81 490.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M140.38,415a4.63,4.63,0,1,1-4.63-4.63A4.63,4.63,0,0,1,140.38,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M139.69,395a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,139.69,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M139,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,139,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M138.31,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,138.31,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M137.62,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M136.93,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(211.52 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(212.21 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(212.9 510.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M155.84,435a5.32,5.32,0,1,1-5.32-5.32,5.32,5.32,0,0,1,5.32,5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M155.16,415a4.64,4.64,0,1,1-4.64-4.63,4.64,4.64,0,0,1,4.64,4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M154.47,395a3.94,3.94,0,1,1-1.158-2.79A3.95,3.95,0,0,1,154.47,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M153.78,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M153.09,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M152.4,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,152.4,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M151.71,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(226.3 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(226.99 529.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M171.31,454.92a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M170.62,435a5.32,5.32,0,1,1-5.32-5.32A5.32,5.32,0,0,1,170.62,435Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M169.93,415a4.63,4.63,0,1,1-4.63-4.63,4.63,4.63,0,0,1,4.63,4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M169.24,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,169.24,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M168.55,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,168.55,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M167.86,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,167.86,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M167.17,335.08a1.86,1.86,0,1,1-.545-1.325,1.87,1.87,0,0,1,.545,1.325Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M166.49,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(241.07 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(241.76 529.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.09,454.92a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M185.4,435a5.32,5.32,0,1,1-5.32-5.32A5.32,5.32,0,0,1,185.4,435Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M184.71,415a4.63,4.63,0,1,1-4.63-4.63A4.63,4.63,0,0,1,184.71,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M184,395a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,184,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M183.33,375a3.25,3.25,0,1,1-3.25-3.26A3.25,3.25,0,0,1,183.33,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M182.64,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M182,335.08a1.88,1.88,0,1,1-1.87-1.87A1.88,1.88,0,0,1,182,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M181.26,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(255.85 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(256.54 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(257.23 510.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M200.18,435a5.33,5.33,0,1,1-5.33-5.32,5.33,5.33,0,0,1,5.33,5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M199.49,415a4.64,4.64,0,1,1-4.64-4.63A4.64,4.64,0,0,1,199.49,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M198.8,395a3.94,3.94,0,1,1-1.175-2.807A3.95,3.95,0,0,1,198.8,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M198.11,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M197.42,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196.73,335.08a1.87,1.87,0,1,1-.551-1.326,1.88,1.88,0,0,1,.551,1.326Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(270.63 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(271.32 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(272.01 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(272.7 490.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M214.26,415a4.63,4.63,0,1,1-4.63-4.63A4.63,4.63,0,0,1,214.26,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M213.57,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,213.57,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M212.88,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M212.19,355.05a2.56,2.56,0,1,1-2.56-2.56,2.56,2.56,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M211.51,335.08a1.87,1.87,0,1,1-.551-1.326,1.88,1.88,0,0,1,.551,1.326Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M210.82,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(285.4 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(286.09 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(286.78 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(287.47 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(288.16 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M228.35,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,228.35,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M227.66,375a3.25,3.25,0,1,1-3.25-3.26A3.25,3.25,0,0,1,227.66,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M227,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,227,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M226.28,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M225.59,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(300.18 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(300.87 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(301.56 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(302.25 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(302.94 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M243.13,395a3.94,3.94,0,1,1-1.158-2.79A3.95,3.95,0,0,1,243.13,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M242.44,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,242.44,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M241.75,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M241.06,335.08a1.87,1.87,0,1,1-.551-1.326,1.88,1.88,0,0,1,.551,1.326Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M240.37,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(314.96 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(315.65 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(316.34 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(317.03 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(317.72 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M257.9,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,257.9,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M257.21,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M256.52,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,256.52,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M255.84,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,255.84,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M255.15,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(329.73 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(330.42 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(331.11 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(331.8 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(332.49 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M272.68,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,272.68,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M272,375a3.25,3.25,0,1,1-3.25-3.26A3.25,3.25,0,0,1,272,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M271.3,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,271.3,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(335.25 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(335.94 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(344.51 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(345.2 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(345.89 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(346.58 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(347.27 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M287.46,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,287.46,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M286.77,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,286.77,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M286.08,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,286.08,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(350.03 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(350.72 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(359.29 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(359.98 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(360.67 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(361.36 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(362.05 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M302.23,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,302.23,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M301.54,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M300.86,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(364.81 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(365.5 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(374.07 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(374.76 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(375.45 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(376.14 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(376.83 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M317,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,317,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M316.32,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M315.63,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,315.63,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(379.59 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(380.28 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(388.84 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(389.53 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(390.22 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(390.91 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(391.6 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M331.79,395a3.95,3.95,0,1,1-3.94-3.94,3.95,3.95,0,0,1,3.94,3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M331.1,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,331.1,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M330.41,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(394.36 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(395.05 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(403.62 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(404.31 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(405 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(405.69 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(406.38 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M346.56,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,346.56,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M345.88,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,345.88,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M345.19,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,345.19,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(409.14 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(409.83 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(418.4 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(419.09 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(419.78 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(420.47 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(421.16 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M361.34,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,361.34,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.65,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,360,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(423.92 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(424.61 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(433.17 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(433.86 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(434.55 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(435.24 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(435.93 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M376.12,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,376.12,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M375.43,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M374.74,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(438.69 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(439.38 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(447.95 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(448.64 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(449.33 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(450.02 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(450.71 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M390.89,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,390.89,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M390.21,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M389.52,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,389.52,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(453.47 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(454.16 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(462.73 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(463.42 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(464.11 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(464.8 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(465.49 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M405.67,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,405.67,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M405,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,405,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M404.29,355.05a2.56,2.56,0,1,1-2.56-2.56,2.56,2.56,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M403.6,335.08a1.87,1.87,0,1,1-1.87-1.87,1.87,1.87,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M402.91,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(477.5 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(478.19 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(478.88 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(479.57 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(480.26 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M420.45,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,420.45,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M419.76,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,419.76,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M419.07,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,419.07,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M418.38,335.08a1.88,1.88,0,1,1-1.87-1.87A1.88,1.88,0,0,1,418.38,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M417.69,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(492.28 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(492.97 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(493.66 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(494.35 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(495.04 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M435.23,395a3.94,3.94,0,1,1-1.175-2.807A3.95,3.95,0,0,1,435.23,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M434.54,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,434.54,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M433.85,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M433.16,335.08a1.87,1.87,0,1,1-.551-1.326,1.88,1.88,0,0,1,.551,1.326Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M432.47,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(507.06 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(507.75 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(508.44 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(509.13 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(509.82 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M450,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,450,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M449.31,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,449.31,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M448.62,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,448.62,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M447.93,335.08a1.86,1.86,0,1,1-.545-1.325,1.87,1.87,0,0,1,.545,1.325Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M447.24,315.11a1.18,1.18,0,1,1-.342-.841A1.18,1.18,0,0,1,447.24,315.11Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(521.83 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(522.52 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(523.21 510.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M466.16,435a5.32,5.32,0,1,1-5.32-5.32,5.32,5.32,0,0,1,5.32,5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M465.47,415a4.63,4.63,0,1,1-4.63-4.63,4.63,4.63,0,0,1,4.63,4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M464.78,395a3.95,3.95,0,1,1-3.94-3.94,3.95,3.95,0,0,1,3.94,3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M464.09,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M463.4,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,463.4,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M462.71,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M462,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(536.61 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(537.3 529.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M481.62,454.92a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M480.93,435a5.32,5.32,0,1,1-5.32-5.32,5.32,5.32,0,0,1,5.32,5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M480.24,415a4.63,4.63,0,1,1-4.63-4.63,4.63,4.63,0,0,1,4.63,4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M479.56,395a3.94,3.94,0,1,1-1.158-2.79A3.95,3.95,0,0,1,479.56,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M478.87,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M478.18,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.49,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,477.49,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M476.8,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(551.39 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(552.08 529.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M496.4,454.92a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M495.71,435a5.32,5.32,0,1,1-5.32-5.32A5.32,5.32,0,0,1,495.71,435Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M495,415a4.63,4.63,0,1,1-4.63-4.63A4.63,4.63,0,0,1,495,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M494.33,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,494.33,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M493.64,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M493,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,493,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M492.26,335.08a1.86,1.86,0,1,1-.545-1.325,1.87,1.87,0,0,1,.545,1.325Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M491.58,315.11a1.19,1.19,0,1,1-1.19-1.19,1.19,1.19,0,0,1,1.19,1.19Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(566.16 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(566.85 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(567.54 510.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M510.49,435a5.32,5.32,0,1,1-5.32-5.32,5.32,5.32,0,0,1,5.32,5.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M509.8,415a4.63,4.63,0,1,1-4.63-4.63A4.63,4.63,0,0,1,509.8,415Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M509.11,395a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,509.11,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M508.42,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M507.73,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M507,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M506.35,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(580.94 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(581.63 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(582.32 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(583.01 490.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M524.58,415a4.64,4.64,0,1,1-4.64-4.63,4.64,4.64,0,0,1,4.64,4.63Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M523.89,395a3.94,3.94,0,1,1-1.158-2.79A3.95,3.95,0,0,1,523.89,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M523.2,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,523.2,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M522.51,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,522.51,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M521.82,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,521.82,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M521.13,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(595.72 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(596.41 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(597.1 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(597.79 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(598.48 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538.66,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,538.66,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,538,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M537.28,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,537.28,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M536.59,335.08a1.86,1.86,0,1,1-.545-1.325,1.87,1.87,0,0,1,.545,1.325Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M535.91,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(610.49 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(611.18 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(611.87 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(612.56 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(613.25 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M553.44,395a3.94,3.94,0,1,1-3.94-3.94,3.94,3.94,0,0,1,3.94,3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M552.75,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M552.06,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M551.37,335.08a1.88,1.88,0,1,1-1.87-1.87,1.88,1.88,0,0,1,1.87,1.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M550.68,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(625.27 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(625.96 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(626.65 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(627.34 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(628.03 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M568.22,395a3.94,3.94,0,1,1-1.175-2.807A3.95,3.95,0,0,1,568.22,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M567.53,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M566.84,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,566.84,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M566.15,335.08a1.87,1.87,0,1,1-.551-1.326A1.88,1.88,0,0,1,566.15,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M565.46,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(640.05 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(640.74 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(641.43 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(642.12 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(642.81 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M583,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,583,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M582.3,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,582.3,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M581.61,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,581.61,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(645.57 394.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M580.24,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(654.82 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(655.51 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(656.2 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(656.89 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(657.58 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M597.77,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,597.77,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M597.08,375a3.25,3.25,0,1,1-3.25-3.26A3.25,3.25,0,0,1,597.08,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M596.39,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(660.34 394.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M595,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(669.6 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(670.29 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(670.98 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(671.67 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(672.36 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M612.55,395a3.94,3.94,0,1,1-1.158-2.79A3.95,3.95,0,0,1,612.55,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M611.86,375a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,611.86,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M611.17,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,611.17,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(675.12 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(675.81 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(684.38 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(685.07 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(685.76 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(686.45 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(687.14 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M627.32,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,627.32,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M626.63,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,626.63,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M625.94,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,625.94,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(689.9 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(690.59 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(699.15 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(699.84 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(700.53 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(701.22 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(701.91 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M642.1,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,642.1,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M641.41,375a3.25,3.25,0,1,1-3.25-3.26,3.25,3.25,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M640.72,355.05a2.56,2.56,0,1,1-2.56-2.56,2.56,2.56,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(704.67 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(705.36 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(713.93 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(714.62 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(715.31 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(716 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(716.69 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M656.88,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,656.88,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M656.19,375a3.26,3.26,0,1,1-3.25-3.26A3.26,3.26,0,0,1,656.19,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M655.5,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(719.45 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(720.14 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(728.71 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(729.4 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(730.09 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(730.78 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(731.47 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M671.65,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,671.65,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M671,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,671,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M670.28,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,670.28,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(734.23 394.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M668.9,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(743.49 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(744.18 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(744.87 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(745.56 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(746.25 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M686.43,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,686.43,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M685.74,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M685.05,355.05a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,685.05,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(749.01 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(749.7 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(758.26 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(758.95 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(759.64 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(760.33 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(761.02 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M701.21,395a3.95,3.95,0,1,1-3.94-3.94,3.95,3.95,0,0,1,3.94,3.94Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M700.52,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M699.83,355.05a2.57,2.57,0,1,1-2.56-2.56A2.57,2.57,0,0,1,699.83,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(763.78 394.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(764.47 375.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(773.04 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(773.73 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(774.42 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(775.11 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(775.8 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M716,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,716,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M715.29,375a3.25,3.25,0,1,1-.948-2.3,3.25,3.25,0,0,1,.948,2.3Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M714.61,355.05a2.57,2.57,0,1,1-2.57-2.56,2.57,2.57,0,0,1,2.57,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.87,
    cy: 1.87,
    r: 1.87,
    transform: "translate(778.56 394.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M713.23,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(787.82 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(788.51 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(789.2 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(789.89 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(790.58 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M730.76,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,730.76,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M730.07,375a3.25,3.25,0,1,1-.948-2.3A3.25,3.25,0,0,1,730.07,375Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M729.38,355.05a2.56,2.56,0,1,1-2.56-2.56,2.56,2.56,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M728.69,335.08a1.87,1.87,0,1,1-1.87-1.87A1.87,1.87,0,0,1,728.69,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M728,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(802.59 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(803.28 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(803.97 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(804.66 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(805.35 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M745.54,395a3.95,3.95,0,1,1-3.94-3.94A3.95,3.95,0,0,1,745.54,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M744.85,375a3.26,3.26,0,1,1-3.25-3.26,3.26,3.26,0,0,1,3.25,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M744.16,355.05a2.57,2.57,0,1,1-2.56-2.56,2.57,2.57,0,0,1,2.56,2.56Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M743.47,335.08a1.88,1.88,0,1,1-1.87-1.87A1.88,1.88,0,0,1,743.47,335.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M742.78,315.11a1.18,1.18,0,1,1-.342-.841,1.19,1.19,0,0,1,.342.841Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.39,
    cy: 7.39,
    r: 7.39,
    transform: "translate(817.37 548.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.7,
    cy: 6.7,
    r: 6.7,
    transform: "translate(818.06 529.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.01,
    cy: 6.01,
    r: 6.01,
    transform: "translate(818.75 510.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    transform: "translate(819.44 490.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.63,
    cy: 4.63,
    r: 4.63,
    transform: "translate(820.13 471.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M760.31,395a3.93,3.93,0,1,1-1.151-2.789A3.94,3.94,0,0,1,760.31,395Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M759.63,375a3.26,3.26,0,1,1-3.26-3.26,3.26,3.26,0,0,1,3.26,3.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M758.94,355.05a2.57,2.57,0,1,1-2.57-2.56A2.57,2.57,0,0,1,758.94,355.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M758.25,335.08a1.87,1.87,0,1,1-.551-1.326,1.88,1.88,0,0,1,.551,1.326Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M757.56,315.11a1.18,1.18,0,1,1-.346-.844,1.19,1.19,0,0,1,.346.844Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M818.42,332.1l-48.19,49.57,48.19,43.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M818.42,425.69l-48.19,49.57,48.19,43.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,169.05a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,169.05a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,169.05a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    transform: "translate(65.79 228.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,169.05a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,169.05a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,169.05a2.1,2.1,0,1,1-2.09-2.1A2.1,2.1,0,0,1,55.21,169.05Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    transform: "translate(137.27 228.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,169.05a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,183.91a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.09,2.09,0,0,1,.616-1.481,2.09,2.09,0,0,1,1.484-.609,2.09,2.09,0,0,1,1.484.609A2.09,2.09,0,0,1-52,183.91Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,183.91a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.09,2.09,0,0,1,.616-1.481,2.09,2.09,0,0,1,1.484-.609,2.09,2.09,0,0,1,1.484.609A2.09,2.09,0,0,1-34.14,183.91Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,183.91a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.09,2.09,0,0,1,.616-1.481,2.09,2.09,0,0,1,1.484-.609,2.09,2.09,0,0,1,1.484.609,2.09,2.09,0,0,1,.616,1.481Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,183.91A2.1,2.1,0,0,1-.5,186a2.1,2.1,0,0,1-2.1-2.1,2.09,2.09,0,0,1,.616-1.481A2.09,2.09,0,0,1-.5,181.81a2.09,2.09,0,0,1,1.488.612A2.09,2.09,0,0,1,1.6,183.91Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,183.91a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,183.91a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,183.91a2.1,2.1,0,1,1-2.09-2.09A2.1,2.1,0,0,1,55.21,183.91Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,183.91a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,183.91a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,198.77a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,198.77a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,198.77a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,198.77a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,198.77a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,198.77a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,198.77a2.1,2.1,0,1,1-2.09-2.09A2.1,2.1,0,0,1,55.21,198.77Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,198.77a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,198.77a2.1,2.1,0,1,1-2.1-2.09,2.1,2.1,0,0,1,2.1,2.09Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,213.64a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,213.64a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,213.64a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,213.64a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,213.64a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,213.64a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,37.34,213.64Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,213.64a2.1,2.1,0,1,1-2.09-2.1A2.1,2.1,0,0,1,55.21,213.64Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,213.64a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,73.09,213.64Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,213.64a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,91,213.64Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,228.5a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-52,228.5Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,228.5a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-34.14,228.5Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,228.5a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-16.27,228.5Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,228.5a2.1,2.1,0,0,1-2.1,2.09,2.1,2.1,0,0,1-2.1-2.09,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,228.5a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,228.5a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,228.5a2.1,2.1,0,1,1-2.09-2.1A2.1,2.1,0,0,1,55.21,228.5Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,228.5a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,228.5a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,243.36a2.09,2.09,0,0,1-.616,1.481,2.09,2.09,0,0,1-1.484.609,2.09,2.09,0,0,1-1.484-.609,2.09,2.09,0,0,1-.616-1.481,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-52,243.36Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,243.36a2.09,2.09,0,0,1-.616,1.481,2.09,2.09,0,0,1-1.484.609,2.09,2.09,0,0,1-1.484-.609,2.09,2.09,0,0,1-.616-1.481,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-34.14,243.36Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,243.36a2.09,2.09,0,0,1-.616,1.481,2.09,2.09,0,0,1-1.484.609,2.09,2.09,0,0,1-1.484-.609,2.09,2.09,0,0,1-.616-1.481,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-16.27,243.36Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    transform: "translate(65.79 302.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,243.36a2.09,2.09,0,1,1-.612-1.488,2.1,2.1,0,0,1,.612,1.488Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,243.36a2.09,2.09,0,1,1-.612-1.488A2.1,2.1,0,0,1,37.34,243.36Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,243.36a2.09,2.09,0,1,1-.609-1.484,2.1,2.1,0,0,1,.609,1.484Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    transform: "translate(137.27 302.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,243.36a2.09,2.09,0,1,1-.612-1.488A2.1,2.1,0,0,1,91,243.36Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,258.22a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-52,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,258.22a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-34.14,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,258.22a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-16.27,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,258.22a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,258.22a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,258.22a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,37.34,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,258.22a2.1,2.1,0,1,1-2.09-2.1,2.1,2.1,0,0,1,2.09,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,258.22a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,73.09,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,258.22a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,91,258.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-52,273.08a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-52,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-34.14,273.08a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-34.14,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-16.27,273.08a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1,2.1,2.1,0,0,1,2.1-2.1A2.1,2.1,0,0,1-16.27,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.6,273.08a2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1A2.1,2.1,0,0,1-.5,271a2.1,2.1,0,0,1,2.1,2.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19.47,273.08a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.34,273.08a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,37.34,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M55.21,273.08a2.1,2.1,0,1,1-2.09-2.1A2.1,2.1,0,0,1,55.21,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M73.09,273.08A2.1,2.1,0,1,1,71,271a2.1,2.1,0,0,1,2.09,2.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91,273.08a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,91,273.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.75,
    cy: 2.75,
    r: 2.75,
    transform: "translate(423.19 416.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,357.8a2.74,2.74,0,1,1-.8-1.947A2.75,2.75,0,0,1,383.69,357.8Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,357.8a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,407.07,357.8Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,357.8a2.74,2.74,0,1,1-.8-1.947,2.75,2.75,0,0,1,.8,1.947Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,357.8a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,453.84,357.8Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,357.8a2.74,2.74,0,1,1-.8-1.947A2.75,2.75,0,0,1,477.23,357.8Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,377.25a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,377.25a2.75,2.75,0,1,1-2.75-2.75A2.75,2.75,0,0,1,383.69,377.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,377.25a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,407.07,377.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,377.25a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,377.25a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,453.84,377.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,377.25a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,396.69a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,396.69a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,396.69a2.75,2.75,0,1,1-2.74-2.74A2.75,2.75,0,0,1,407.07,396.69Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,396.69a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,396.69A2.75,2.75,0,1,1,451.1,394,2.75,2.75,0,0,1,453.84,396.69Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,396.69a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,416.14a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,416.14a2.75,2.75,0,1,1-2.75-2.75A2.75,2.75,0,0,1,383.69,416.14Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,416.14a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,407.07,416.14Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,416.14a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,416.14a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,453.84,416.14Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,416.14a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,435.58a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,435.58a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,435.58a2.75,2.75,0,1,1-2.74-2.74A2.75,2.75,0,0,1,407.07,435.58Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,435.58a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,435.58a2.75,2.75,0,1,1-2.74-2.74,2.75,2.75,0,0,1,2.74,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,435.58a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,455a2.75,2.75,0,1,1-2.75-2.75A2.75,2.75,0,0,1,360.3,455Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,455a2.75,2.75,0,1,1-2.75-2.75A2.75,2.75,0,0,1,383.69,455Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,455a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,407.07,455Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,455a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,455a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,453.84,455Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,455a2.75,2.75,0,1,1-2.75-2.75,2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,474.47a2.75,2.75,0,1,1-2.75-2.74A2.75,2.75,0,0,1,360.3,474.47Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,474.47a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,474.47a2.75,2.75,0,1,1-2.74-2.74A2.75,2.75,0,0,1,407.07,474.47Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,474.47a2.75,2.75,0,1,1-2.75-2.74A2.75,2.75,0,0,1,430.46,474.47Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,474.47a2.75,2.75,0,1,1-2.74-2.74,2.75,2.75,0,0,1,2.74,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,474.47a2.75,2.75,0,1,1-2.75-2.74,2.75,2.75,0,0,1,2.75,2.74Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M360.3,493.92a2.74,2.74,0,1,1-.8-1.947,2.75,2.75,0,0,1,.8,1.947Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M383.69,493.92a2.74,2.74,0,1,1-.8-1.947,2.75,2.75,0,0,1,.8,1.947Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.07,493.92a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,407.07,493.92Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.46,493.92a2.74,2.74,0,1,1-.8-1.947,2.75,2.75,0,0,1,.8,1.947Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M453.84,493.92a2.74,2.74,0,1,1-.8-1.944A2.75,2.75,0,0,1,453.84,493.92Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.23,493.92a2.74,2.74,0,1,1-.8-1.947,2.75,2.75,0,0,1,.8,1.947Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M495.51,170.08a1.26,1.26,0,1,1-1.26-1.26,1.26,1.26,0,0,1,1.26,1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M506.21,170.08a1.26,1.26,0,1,1-1.26-1.26,1.26,1.26,0,0,1,1.26,1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M516.91,170.08a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,516.91,170.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M527.61,170.08a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,527.61,170.08Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538.3,170.08a1.26,1.26,0,1,1-1.25-1.26,1.26,1.26,0,0,1,1.25,1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M549,170.08a1.26,1.26,0,1,1-1.25-1.26,1.26,1.26,0,0,1,1.25,1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(561.38 238.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(572.08 238.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(582.78 238.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M527.61,179a1.26,1.26,0,1,1-1.26-1.26,1.26,1.26,0,0,1,1.26,1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538.3,179a1.25,1.25,0,1,1-.362-.89A1.26,1.26,0,0,1,538.3,179Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M549,179a1.25,1.25,0,1,1-.362-.89A1.26,1.26,0,0,1,549,179Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(561.38 247.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(572.08 247.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(582.78 247.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M527.61,187.87a1.26,1.26,0,1,1-1.26-1.25,1.26,1.26,0,0,1,1.26,1.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538.3,187.87a1.26,1.26,0,1,1-1.25-1.25,1.26,1.26,0,0,1,1.25,1.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M549,187.87a1.26,1.26,0,1,1-1.25-1.25,1.26,1.26,0,0,1,1.25,1.25Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,196.67a1.26,1.26,0,1,1-1.26,1.25A1.26,1.26,0,0,1,703.94,196.67Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,186a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,703.94,186Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,175.27a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,703.94,175.27Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,164.57a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,703.94,164.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,153.87a1.26,1.26,0,1,1-1.26,1.26,1.26,1.26,0,0,1,1.26-1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M703.94,143.17a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,703.94,143.17Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(779.96 257.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(779.96 247.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(779.96 236.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M712.84,164.57a1.25,1.25,0,1,1-.894.366,1.26,1.26,0,0,1,.894-.366Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M712.84,153.87a1.25,1.25,0,1,1-.894.366,1.26,1.26,0,0,1,.894-.366Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(779.96 204.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(788.86 257.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(788.86 247.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(788.86 236.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M721.73,164.57a1.25,1.25,0,1,1-.888.37,1.26,1.26,0,0,1,.888-.37Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M721.73,153.87a1.25,1.25,0,1,1-.888.37,1.26,1.26,0,0,1,.888-.37Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(788.86 204.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,196.67a1.26,1.26,0,1,1-1.26,1.25A1.26,1.26,0,0,1,678.5,196.67Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,186a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,678.5,186Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,175.27a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,678.5,175.27Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,164.57a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,678.5,164.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,153.87a1.26,1.26,0,1,1-1.26,1.26,1.26,1.26,0,0,1,1.26-1.26Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M678.5,143.17a1.26,1.26,0,1,1-1.26,1.26A1.26,1.26,0,0,1,678.5,143.17Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(754.52 257.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(754.52 247.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(754.52 236.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M687.4,164.57a1.25,1.25,0,1,1-.894.366,1.26,1.26,0,0,1,.894-.366Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M687.4,153.87a1.25,1.25,0,1,1-.894.366,1.26,1.26,0,0,1,.894-.366Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(754.52 204.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(763.42 257.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(763.42 247.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(763.42 236.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M696.29,164.57a1.25,1.25,0,1,1-.887.37A1.26,1.26,0,0,1,696.29,164.57Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M696.29,153.87a1.25,1.25,0,1,1-.887.37A1.26,1.26,0,0,1,696.29,153.87Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.26,
    cy: 1.26,
    r: 1.26,
    transform: "translate(763.42 204.29)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M10.84,381.71a79.22,79.22,0,1,0,79.21,79.217A79.222,79.222,0,0,0,10.84,381.71Zm0,153.38A74.16,74.16,0,1,1,85,460.93a74.16,74.16,0,0,1-74.16,74.16Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M10.84,398.84a62.1,62.1,0,1,0,62.09,62.093A62.1,62.1,0,0,0,10.84,398.84Zm0,114.7a52.61,52.61,0,1,1,52.6-52.607,52.612,52.612,0,0,1-52.6,52.607Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M10.84,426.08a34.85,34.85,0,1,0,34.85,34.85,34.85,34.85,0,0,0-34.85-34.85Zm0,53.57a18.72,18.72,0,1,1,18.71-18.717A18.72,18.72,0,0,1,10.84,479.65Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M284.63-61.12a72.86,72.86,0,1,0,72.85,72.857A72.862,72.862,0,0,0,284.63-61.12Zm0,141.05a68.047,68.047,0,1,0-.007,0Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M284.63-45.37a57.11,57.11,0,1,0,57.1,57.107,57.112,57.112,0,0,0-57.1-57.107Zm0,105.48a48.422,48.422,0,1,1,.007,0Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M284.63-20.32a32.053,32.053,0,1,1-.007,0Zm0,49.26a17.21,17.21,0,1,1,17.21-17.2,17.21,17.21,0,0,1-17.21,17.2Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M529.78,232.79a51.76,51.76,0,1,0,51.76,51.76A51.76,51.76,0,0,0,529.78,232.79Zm0,100.22a48.75,48.75,0,1,0,0-.01Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M529.78,254.87a29.69,29.69,0,1,0,29.68,29.683,29.69,29.69,0,0,0-29.68-29.683Zm0,54.83a25.15,25.15,0,1,1,25.15-25.15,25.15,25.15,0,0,1-25.15,25.15Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M660.64-30.15A51.76,51.76,0,1,0,712.4,21.61a51.76,51.76,0,0,0-51.76-51.76Zm0,93.69a41.93,41.93,0,1,1,41.93-41.93,41.93,41.93,0,0,1-41.93,41.93Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M685.36,262.16c-7.68,2.52-14.44-4.85-21.77-6.59a17.37,17.37,0,0,0-9.13.29c-3.48,1-6.32,3.65-9.59,5.43-6.77,3.69-13.62,1.6-19.54-3.82-2.29-2.1-4.66-4.21-7.45-4.46-3.32-.28-6.42,1.92-9.07,4.52-.9.88,0,3,.86,2.1,3.35-3.28,7.19-5.56,11.17-3.07,2.82,1.76,5.16,4.75,8,6.5a16.23,16.23,0,0,0,17.17.18c3.25-1.93,6.16-4.38,9.68-5.26A17.17,17.17,0,0,1,667,259.26c6.21,2.78,12.15,7.44,18.84,5.24C686.89,264.14,686.44,261.8,685.36,262.16Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M685.36,252.66c-7.68,2.53-14.44-4.84-21.77-6.59a17.37,17.37,0,0,0-9.13.29c-3.48,1-6.32,3.65-9.59,5.43-6.77,3.69-13.62,1.6-19.54-3.82-2.29-2.1-4.66-4.21-7.45-4.45-3.32-.29-6.42,1.91-9.07,4.51-.9.88,0,3,.86,2.1,3.35-3.28,7.19-5.56,11.17-3.07,2.82,1.76,5.16,4.75,8,6.5a16.23,16.23,0,0,0,17.17.18c3.25-1.93,6.16-4.38,9.68-5.26A17.17,17.17,0,0,1,667,249.76c6.21,2.78,12.15,7.44,18.84,5.24C686.89,254.64,686.44,252.3,685.36,252.66Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M685.36,243.16c-7.68,2.53-14.44-4.84-21.77-6.59a17.37,17.37,0,0,0-9.13.29c-3.48,1-6.32,3.65-9.59,5.43-6.77,3.7-13.62,1.6-19.54-3.82-2.29-2.1-4.66-4.21-7.45-4.45-3.32-.29-6.42,1.91-9.07,4.51-.9.88,0,3,.86,2.1,3.35-3.28,7.19-5.56,11.17-3.07,2.82,1.76,5.16,4.75,8,6.5a16.23,16.23,0,0,0,17.17.18c3.25-1.93,6.16-4.38,9.68-5.26A17.23,17.23,0,0,1,667,240.26c6.21,2.78,12.15,7.44,18.84,5.24C686.89,245.15,686.44,242.81,685.36,243.16Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M151.27,414.11v13.15H116.22V392.2h13.15v21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M175.01,390.37v13.15H139.95V368.47H153.1v21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M198.75,366.64v13.15H163.69V344.73h13.15v21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M222.48,342.9v13.15H187.43V321h13.14v21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M524.28,178.41v13.15H489.23V156.5h13.15v21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M548.02,154.67v13.15H512.96V132.76h13.15v21.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M571.75,130.93v13.15H536.7V109.03h13.15v21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M595.49,107.2v13.15H560.43V85.29h13.15V107.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M308.5,262.81a22.854,22.854,0,0,1-32.32-32.32Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M573.91,410a38.11,38.11,0,1,1,53.89,53.9Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M168.4,366.78a38.11,38.11,0,1,1,0,76.22Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M193.68,103.28c-3.67,6.41-10.54,6.53-15.7,2-2.38-2.1-4.5-4.57-7.53-5.76a11.82,11.82,0,0,0-8.81.08c-3.72,1.54-5.26,4.84-8,7.52-2.27,2.23-5.62,3.82-8.77,2.18-2.13-1.12-3.06-3.71-4.64-5.4a11.86,11.86,0,0,0-7.14-3.6c-6.13-.8-11.07,3.2-13.11,8.73-.85,2.31,2.83,3.3,3.67,1,2.15-5.85,9.28-8.24,13.89-3.46,2.5,2.6,3.41,5.51,7.1,6.71,6.52,2.12,10.72-2.74,14.59-7,8.68-9.64,13.84,2.59,21.68,5.36,6.4,2.26,12.79-.76,16.05-6.44C198.19,103.07,194.9,101.15,193.68,103.28Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M193.68,117.17c-3.67,6.41-10.54,6.53-15.7,2-2.38-2.09-4.5-4.56-7.53-5.75a11.82,11.82,0,0,0-8.81.08c-3.72,1.53-5.26,4.84-8,7.51-2.27,2.23-5.62,3.83-8.77,2.18-2.13-1.11-3.06-3.71-4.64-5.39a11.93,11.93,0,0,0-7.14-3.61c-6.13-.79-11.07,3.21-13.11,8.74-.85,2.3,2.83,3.3,3.67,1,2.15-5.84,9.28-8.23,13.89-3.45,2.5,2.6,3.41,5.51,7.1,6.71,6.52,2.12,10.72-2.74,14.59-7,8.68-9.64,13.84,2.59,21.68,5.35,6.4,2.26,12.79-.75,16.05-6.43C198.19,117,194.9,115,193.68,117.17Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M741.18,382.73c-1.61,2.8-4.61,2.85-6.86.88A12,12,0,0,0,731,381.1a5.18,5.18,0,0,0-3.85,0c-1.62.67-2.29,2.11-3.49,3.28a3.31,3.31,0,0,1-3.83,1c-.93-.49-1.34-1.62-2-2.36a5.18,5.18,0,0,0-3.11-1.57,5.41,5.41,0,0,0-5.73,3.81c-.37,1,1.24,1.44,1.6.44a3.63,3.63,0,0,1,6.07-1.5c1.09,1.13,1.49,2.4,3.1,2.93,2.85.92,4.69-1.2,6.37-3.08,3.79-4.21,6,1.13,9.47,2.34a5.79,5.79,0,0,0,7-2.81.83.83,0,0,0-1.42-.85Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M741.18,377c-1.61,2.8-4.61,2.85-6.86.88a12,12,0,0,0-3.29-2.51,5.18,5.18,0,0,0-3.85,0c-1.62.67-2.29,2.11-3.49,3.28a3.31,3.31,0,0,1-3.83,1c-.93-.49-1.34-1.62-2-2.36a5.18,5.18,0,0,0-3.11-1.57,5.41,5.41,0,0,0-5.73,3.81c-.37,1,1.24,1.44,1.6.44a3.63,3.63,0,0,1,6.07-1.5c1.09,1.13,1.49,2.4,3.1,2.93,2.85.92,4.69-1.2,6.37-3.08,3.79-4.21,6,1.13,9.47,2.34a5.79,5.79,0,0,0,7-2.81.84.84,0,0,0-1.45-.85Z",
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M741.18,388.8c-1.61,2.79-4.61,2.85-6.86.88a11.831,11.831,0,0,0-3.29-2.52,5.18,5.18,0,0,0-3.85,0c-1.62.67-2.29,2.11-3.49,3.28a3.32,3.32,0,0,1-3.83.95c-.93-.48-1.34-1.62-2-2.35a5.19,5.19,0,0,0-3.11-1.58,5.41,5.41,0,0,0-5.73,3.82c-.37,1,1.24,1.44,1.6.44.94-2.55,4.06-3.6,6.07-1.51,1.09,1.14,1.49,2.41,3.1,2.93,2.85.93,4.69-1.2,6.37-3.07,3.79-4.21,6,1.13,9.47,2.34a5.8,5.8,0,0,0,7-2.82.83.83,0,0,0-1.45-.79Z",
    transform: "translate(68.39 61.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 170.397,
    height: 139.032,
    transform: "translate(42.869 261.239) rotate(-66.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 170.397,
    height: 139.032,
    transform: "translate(37.827 253.414) rotate(-66.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M567.5,495.482a1.266,1.266,0,0,1-1.691.532l-85-36.552a1.172,1.172,0,1,1,.916-2.129l85,36.552A1.26,1.26,0,0,1,567.5,495.482Z",
    transform: "translate(-405.419 -234.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M535.039,488.349a1.26,1.26,0,0,1-1.691.532l-55.023-23.658a1.172,1.172,0,1,1,.916-2.129l55.023,23.658a1.26,1.26,0,0,1,.775,1.6Z",
    transform: "translate(-404.61 -236.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M518.763,488.284a1.26,1.26,0,0,1-1.691.532l-41.267-17.744a1.172,1.172,0,1,1,.916-2.129l41.267,17.744A1.26,1.26,0,0,1,518.763,488.284Z",
    transform: "translate(-403.788 -238.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M546.105,462.681a1.273,1.273,0,0,1-1.7.532l-55.023-23.658a1.172,1.172,0,1,1,.916-2.135l55.023,23.665A1.266,1.266,0,0,1,546.105,462.681Z",
    transform: "translate(-408.226 -228.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M537.6,444.474a1.266,1.266,0,0,1-1.7.532l-41.26-17.744a1.172,1.172,0,1,1,.916-2.129l41.26,17.744A1.266,1.266,0,0,1,537.6,444.474Z",
    transform: "translate(-409.937 -224.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M527.493,447.411a1.267,1.267,0,0,1-1.691.539l-33.8-14.537a1.172,1.172,0,1,1,.916-2.129l33.823,14.53A1.26,1.26,0,0,1,527.493,447.411Z",
    transform: "translate(-409.075 -226.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M592.477,524.22a.52.52,0,0,1-.2-.04.525.525,0,0,1-.29-.344l-1.482-6.2a.512.512,0,0,1,.3-.586.466.466,0,0,1,.189,0,.5.5,0,0,1,.431.243l2.189,3.6,8.084-2.694a.453.453,0,0,1,.162,0,.505.505,0,0,1,.243.95l-9.364,5.106A.5.5,0,0,1,592.477,524.22Z",
    transform: "translate(-441.503 -254.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M590.75,517.27l2.4,3.941,8.447-2.85-9.364,5.14-1.482-6.2M601.6,518.4h0m-10.846-2.1a.967.967,0,0,0-.384.074,1.011,1.011,0,0,0-.6,1.165l1.482,6.2a1.01,1.01,0,0,0,.573.674.982.982,0,0,0,.411.088,1.017,1.017,0,0,0,.485-.121l9.323-5.113a1.011,1.011,0,0,0-.411-1.913h-.2a.941.941,0,0,0-.2.054l-7.659,2.587-1.967-3.227a1,1,0,0,0-.862-.485Z",
    transform: "translate(-441.258 -253.835)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "w",
    transform: "matrix(0.395, -0.919, 0.919, 0.395, 175.582, 186.719)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39,
    y: 0
  }, "\uDB81\uDC15"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.521 434.025) rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M163.658,659.074a7.808,7.808,0,0,1-11.048,0h0a7.808,7.808,0,0,1,0-11.048l10.839-10.846a7.808,7.808,0,0,1,11.048,0h0a7.808,7.808,0,0,1,0,11.048Z",
    transform: "translate(-297.848 -292.545)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 7.491,
    height: 15.743,
    transform: "matrix(0.707, -0.708, 0.708, 0.707, -143.307, 353.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M284.6,517.913l11.135,11.122L306.1,507.64Z",
    transform: "translate(-341.672 -251.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M313.576,507.15l-6.736,3.22,3.489,3.483Z",
    transform: "translate(-348.93 -250.856)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 114.727,
    height: 15.75,
    transform: "translate(-138.049 348.206) rotate(-45.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    width: 114.727,
    height: 6.905,
    transform: "translate(-134.918 351.324) rotate(-45.11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLethnerBgCustom);
export default __webpack_public_path__ + "static/media/LethnerBG-Custom.b94c93cda02bac0535feff691105344d.svg";
export { ForwardRef as ReactComponent };